import AcademyApp from "./AcademyApp";
import { AthleteApp, athleteProfilePath } from "./AthleteApp";

function isAthleteProfileRoute(pathname: string) {
  return pathname === athleteProfilePath || pathname.startsWith(`${athleteProfilePath}/`);
}

export default function App() {
  return isAthleteProfileRoute(window.location.pathname) ? <AthleteApp /> : <AcademyApp />;
}
